import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Layout from '../components/Layout';
import './CareerPage.css';

const CareerPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('all');

  const jobPostings = [
    {
      id: 1,
      slug: "RA-electronics-design-engineer",
      title: "Research Associate I - Electronics Design Engineer",
      badge: "Full-time",
      location: "Coimbatore",
      description: "Lead the design, development, and validation of a wearable, non-invasive system for diseases treatment...",
      duration: "Up to 36 months ( may extend )",
      fellowship: "As per norms",
      type: "Full-time Research Position",
      category: "electronics"
    },
    {
      id: 2,
      slug: "SRF-electronics-design-engineer",
      title: "Senior Research Fellow ( SRF ) - Electronics Design Engineer",
      badge: "Full-time",
      location: "Coimbatore",
      description: "Lead research activities in advanced electronics circuit design, power management architecture, sensor systems...",
      duration: "Up to 36 months ( may extend )",
      fellowship: "As per norms",
      type: "Full-time Research Position",
      category: "electronics"
    },
    {
      id: 3,
      slug: "JRF-electronics-design-engineer",
      title: "Junior Research Fellow ( JRF ) - Electronics Design Engineer",
      badge: "Full-time",
      location: "Coimbatore",
      description: "Support electronic circuit design, power management, sensor interfacing, and circuit analysis...",
      duration: "Up to 36 months ( may extend )",
      fellowship: "As per norms",
      type: "Full-time Research Position",
      category: "electronics"
    },
    {
      id: 4,
      slug: "RA-ML-AI-engineer-livestock-AI",
      title: "Research Associate I - ML/AI Engineer - Livestock AI",
      badge: "Full-time",
      location: "Coimbatore",
      description: "Lead the machine learning and AI architecture for disease prediction/modelling, forecasting, and real-time treatment monitoring...",
      duration: "Up to 36 months ( may extend )",
      fellowship: "As per norms",
      type: "Full-time Research Position",
      category: "ai"
    },
    {
      id: 5,
      slug: "SRF-ML-AI-engineer-livestock-AI",
      title: "Senior Research Fellow ( SRF ) - ML/AI Engineer - Livestock AI",
      badge: "Full-time",
      location: "Coimbatore",
      description: "Lead the ML/AI workstream: design the end-to-end ML strategy for Diseases prediction and real-time treatment monitoring...",
      duration: "Up to 36 months ( may extend )",
      fellowship: "As per norms",
      type: "Full-time Research Position",
      category: "ai"
    },
    {
      id: 6,
      slug: "JRF-ML-AI-engineer-livestock-AI",
      title: "Junior Research Fellow ( JRF ) - ML/AI Engineer - Livestock AI",
      badge: "Full-time",
      location: "Coimbatore",
      description: "Support development of machine learning models for diseases risk prediction and treatment monitoring...",
      duration: "Up to 36 months ( may extend )",
      fellowship: "As per norms",
      type: "Full-time Research Position",
      category: "ai"
    },
    {
      id: 7,
      slug: "RA-microbiologist-livestock-AI",
      title: "Research Associate I - Microbiologist / Biotechnologist - Livestock AI",
      badge: "Full-time",
      location: "Coimbatore",
      description: "Provide independent biological leadership for validating the non-invasive treatment and clinical trial readiness...",
      duration: "Up to 36 months ( may extend )",
      fellowship: "As per norms",
      type: "Full-time Research Position",
      category: "microbiology"
    },
    {
      id: 8,
      slug: "SRF-microbiologist-livestock-AI",
      title: "Senior Research Fellow ( SRF ) - Microbiologist / Biotechnologist - Livestock AI",
      badge: "Full-time",
      location: "Coimbatore",
      description: "Responsible for biological and microbiological validation of the proposed treatment system...",
      duration: "Up to 36 months ( may extend )",
      fellowship: "As per norms",
      type: "Full-time Research Position",
      category: "microbiology"
    },
    {
      id: 9,
      slug: "JRF-biotechnologist-livestock-AI",
      title: "Junior Research Fellow ( JRF ) - Microbiologist / Biotechnologist - Livestock AI",
      badge: "Closed",
      location: "Coimbatore",
      description: "Support microbiological and biological experiments, assist in wet lab activities and data generation...",
      duration: "Up to 36 months ( may extend )",
      fellowship: "As per norms",
      type: "Full-time Research Position",
      isClosed: true,
      category: "microbiology"
    },
    {
      id: 10,
      slug: "project-assistant-microbiology",
      title: "Project Assistant - Microbiology / Biotechnology",
      badge: "Full-time",
      location: "Coimbatore",
      description: "Support wetlab execution, routine microbiological workflows, biological data generation, and sample processing...",
      duration: "Up to 36 months ( may extend )",
      fellowship: "As per norms",
      type: "Full-time Research Position",
      isClosed: false,
      category: "microbiology"
    },
    {
      id: 11,
      slug: "project-assistant-electronics",
      title: "Project Assistant - Electronics Design Engineer",
      badge: "Full-time",
      location: "Coimbatore",
      description: "Support electronics circuit design, PCB development, component selection, prototype assembly, and testing...",
      duration: "Up to 36 months ( may extend )",
      fellowship: "As per norms",
      type: "Full-time Research Position",
      isClosed: false,
      category: "electronics"
    },
    {
      id: 12,
      slug: "project-assistant-ai",
      title: "Project Assistant - ML/AI Engineer - Livestock AI",
      badge: "Full-time",
      location: "Coimbatore",
      description: "Support ML/AI model development, data preparation, model training and evaluation, and technical documentation...",
      duration: "Up to 36 months ( may extend )",
      fellowship: "As per norms",
      type: "Full-time Research Position",
      isClosed: false,
      category: "ai"
    }
  ];

  const handleApplyClick = (jobSlug) => {
    // Navigate to detailed job view using slug
    navigate(`/careers/${jobSlug}`);
  };

  // Filter jobs based on active tab
  const filteredJobs = activeTab === 'all' 
    ? jobPostings 
    : jobPostings.filter(job => job.category === activeTab);

  return (
    <Layout>
      <Helmet>
        <title>Careers - Adept Knowledge Technologies</title>
        <meta name="description" content="Join Adept Knowledge Technologies — explore open research positions in electronics design, ML/AI engineering, and microbiology. Work on cutting-edge precision diagnostics for dairy animal health." />
        <link rel="canonical" href="https://www.ak-tech.in/careers" />
        <meta property="og:title" content="Careers - Adept Knowledge Technologies" />
        <meta property="og:description" content="Open research positions in electronics design, ML/AI engineering, and microbiology at Adept Knowledge Technologies." />
        <meta property="og:url" content="https://www.ak-tech.in/careers" />
        <meta name="twitter:title" content="Careers - Adept Knowledge Technologies" />
        <meta name="twitter:description" content="Open research positions in electronics design, ML/AI engineering, and microbiology at Adept Knowledge Technologies." />
      </Helmet>
      <section className="career-section">
        <div className="career-container">
          {/* Breadcrumbs */}
          <nav className="breadcrumbs" data-aos="fade-up">
            <Link to="/">Home</Link>
            <span className="separator">/</span>
            <span className="current">Careers</span>
          </nav>

          <div className="career-header" data-aos="fade-up">
            <h1>OPEN POSITIONS</h1>
          </div>

          {/* Dark green background section for job cards */}
          <div className="jobs-section">
            {/* Tabs Section */}
            <div className="career-tabs-container" data-aos="fade-up">
              <div className="career-tabs">
                <button
                  className={`career-tab ${activeTab === 'all' ? 'active' : ''}`}
                  onClick={() => setActiveTab('all')}
                >
                  <i className="fas fa-th-large tab-icon"></i>
                  <span className="tab-text">All</span>
                </button>
                <button
                  className={`career-tab ${activeTab === 'electronics' ? 'active' : ''}`}
                  onClick={() => setActiveTab('electronics')}
                >
                  <i className="fas fa-microchip tab-icon"></i>
                  <span className="tab-text">Electronics Design Engineer</span>
                </button>
                <button
                  className={`career-tab ${activeTab === 'ai' ? 'active' : ''}`}
                  onClick={() => setActiveTab('ai')}
                >
                  <i className="fas fa-brain tab-icon"></i>
                  <span className="tab-text">ML/AI Engineer</span>
                </button>
                <button
                  className={`career-tab ${activeTab === 'microbiology' ? 'active' : ''}`}
                  onClick={() => setActiveTab('microbiology')}
                >
                  <i className="fas fa-microscope tab-icon"></i>
                  <span className="tab-text">Microbiologist / Biotechnologist</span>
                </button>
              </div>
            </div>

            <div className="jobs-grid">
              {/* First 3 cards */}
              {filteredJobs.slice(0, 3).map((job) => (
              <div 
                key={job.id} 
                className="job-card" 
                data-aos="fade-up"
              >
                {/* Header with title and badge */}
                <div className="job-card-header">
                  <h3 className="job-title">{job.title}</h3>
                  <span className={`job-badge ${job.isClosed ? 'closed' : ''}`}>{job.badge}</span>
                </div>

                {/* Content box with all details */}
                <div className="job-content-box">
                  <div className="job-details-grid">
                    <div className="detail-item">
                      <span className="detail-label">Duration:</span>
                      <span className="detail-value">{job.duration}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">Fellowship:</span>
                      <span className="detail-value">{job.fellowship}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">Location:</span>
                      <span className="detail-value">{job.location}</span>
                    </div>
                  </div>
                  
                  <div className="job-description">
                    <p>{job.description}</p>
                  </div>
                </div>

                {/* See Details button */}
                <div className="job-card-footer">
                  <button 
                    className="see-details-btn"
                    onClick={() => handleApplyClick(job.slug)}
                  >
                    See Details
                  </button>
                </div>
              </div>
            ))}
            </div>
            
            {/* 4th card centered (if exactly 4 cards) */}
            {filteredJobs.length === 4 && (
              <div className="centered-card-wrapper">
                {filteredJobs.slice(3, 4).map((job) => (
                  <div 
                    key={job.id} 
                    className="job-card" 
                    data-aos="fade-up"
                  >
                    {/* Header with title and badge */}
                    <div className="job-card-header">
                      <h3 className="job-title">{job.title}</h3>
                      <span className={`job-badge ${job.isClosed ? 'closed' : ''}`}>{job.badge}</span>
                    </div>

                    {/* Content box with all details */}
                    <div className="job-content-box">
                      <div className="job-details-grid">
                        <div className="detail-item">
                          <span className="detail-label">Duration:</span>
                          <span className="detail-value">{job.duration}</span>
                        </div>
                        <div className="detail-item">
                          <span className="detail-label">Fellowship:</span>
                          <span className="detail-value">{job.fellowship}</span>
                        </div>
                        <div className="detail-item">
                          <span className="detail-label">Location:</span>
                          <span className="detail-value">{job.location}</span>
                        </div>
                      </div>
                      
                      <div className="job-description">
                        <p>{job.description}</p>
                      </div>
                    </div>

                    {/* See Details button */}
                    <div className="job-card-footer">
                      <button 
                        className="see-details-btn"
                        onClick={() => handleApplyClick(job.slug)}
                      >
                        See Details
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
            
            {/* Cards 4-9 for more than 4 cards */}
            {filteredJobs.length > 4 && (
              <div className="jobs-grid jobs-grid-continuation">
                {filteredJobs.slice(3, 9).map((job) => (
              <div 
                key={job.id} 
                className="job-card" 
                data-aos="fade-up"
              >
                {/* Header with title and badge */}
                <div className="job-card-header">
                  <h3 className="job-title">{job.title}</h3>
                  <span className={`job-badge ${job.isClosed ? 'closed' : ''}`}>{job.badge}</span>
                </div>

                {/* Content box with all details */}
                <div className="job-content-box">
                  <div className="job-details-grid">
                    <div className="detail-item">
                      <span className="detail-label">Duration:</span>
                      <span className="detail-value">{job.duration}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">Fellowship:</span>
                      <span className="detail-value">{job.fellowship}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">Location:</span>
                      <span className="detail-value">{job.location}</span>
                    </div>
                  </div>
                  
                  <div className="job-description">
                    <p>{job.description}</p>
                  </div>
                </div>

                {/* See Details button */}
                <div className="job-card-footer">
                  <button 
                    className="see-details-btn"
                    onClick={() => handleApplyClick(job.slug)}
                  >
                    See Details
                  </button>
                </div>
              </div>
            ))}
              </div>
            )}
            
            {/* Cards 10-12 for more than 9 cards */}
            {filteredJobs.length > 9 && (
              <div className="jobs-grid jobs-grid-continuation">
                {filteredJobs.slice(9, 12).map((job) => (
              <div 
                key={job.id} 
                className="job-card" 
                data-aos="fade-up"
              >
                {/* Header with title and badge */}
                <div className="job-card-header">
                  <h3 className="job-title">{job.title}</h3>
                  <span className={`job-badge ${job.isClosed ? 'closed' : ''}`}>{job.badge}</span>
                </div>

                {/* Content box with all details */}
                <div className="job-content-box">
                  <div className="job-details-grid">
                    <div className="detail-item">
                      <span className="detail-label">Duration:</span>
                      <span className="detail-value">{job.duration}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">Fellowship:</span>
                      <span className="detail-value">{job.fellowship}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">Location:</span>
                      <span className="detail-value">{job.location}</span>
                    </div>
                  </div>
                  
                  <div className="job-description">
                    <p>{job.description}</p>
                  </div>
                </div>

                {/* See Details button */}
                <div className="job-card-footer">
                  <button 
                    className="see-details-btn"
                    onClick={() => handleApplyClick(job.slug)}
                  >
                    See Details
                  </button>
                </div>
              </div>
            ))}
              </div>
            )}
            
            {/* Last card wrapper for laptop/tablet/mobile - remaining cards after 12 */}
            {filteredJobs.length > 12 && (
              <div className="last-cards-wrapper">
                {filteredJobs.slice(12).map((job) => (
                <div 
                  key={job.id} 
                  className="job-card" 
                  data-aos="fade-up"
                >
                  {/* Header with title and badge */}
                  <div className="job-card-header">
                    <h3 className="job-title">{job.title}</h3>
                    <span className={`job-badge ${job.isClosed ? 'closed' : ''}`}>{job.badge}</span>
                  </div>

                  {/* Content box with all details */}
                  <div className="job-content-box">
                    <div className="job-details-grid">
                      <div className="detail-item">
                        <span className="detail-label">Duration:</span>
                        <span className="detail-value">{job.duration}</span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">Fellowship:</span>
                        <span className="detail-value">{job.fellowship}</span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">Location:</span>
                        <span className="detail-value">{job.location}</span>
                      </div>
                    </div>
                    
                    <div className="job-description">
                      <p>{job.description}</p>
                    </div>
                  </div>

                  {/* See Details button */}
                  <div className="job-card-footer">
                    <button 
                      className="see-details-btn"
                      onClick={() => handleApplyClick(job.slug)}
                    >
                      See Details
                    </button>
                  </div>
                </div>
              ))}
              </div>
            )}
            
            {/* Desktop-only wrapper for remaining cards after 12 */}
            {filteredJobs.length > 12 && (
              <div className="desktop-last-two-wrapper">
                {filteredJobs.slice(12, 13).map((job) => (
                <div 
                  key={job.id} 
                  className="job-card" 
                  data-aos="fade-up"
                >
                  {/* Header with title and badge */}
                  <div className="job-card-header">
                    <h3 className="job-title">{job.title}</h3>
                    <span className={`job-badge ${job.isClosed ? 'closed' : ''}`}>{job.badge}</span>
                  </div>

                  {/* Content box with all details */}
                  <div className="job-content-box">
                    <div className="job-details-grid">
                      <div className="detail-item">
                        <span className="detail-label">Duration:</span>
                        <span className="detail-value">{job.duration}</span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">Fellowship:</span>
                        <span className="detail-value">{job.fellowship}</span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">Location:</span>
                        <span className="detail-value">{job.location}</span>
                      </div>
                    </div>
                    
                    <div className="job-description">
                      <p>{job.description}</p>
                    </div>
                  </div>

                  {/* See Details button */}
                  <div className="job-card-footer">
                    <button 
                      className="see-details-btn"
                      onClick={() => handleApplyClick(job.slug)}
                    >
                      See Details
                    </button>
                  </div>
                </div>
              ))}
              </div>
            )}
          </div>
          
          {/* HR Contact Banner */}
          <div className="hr-contact-banner" data-aos="fade-up">
            <div className="banner-circles">
              <div className="circle circle-1"></div>
              <div className="circle circle-2"></div>
              <div className="circle circle-3"></div>
              <div className="circle circle-4"></div>
              <div className="circle-small circle-small-1"></div>
              <div className="circle-small circle-small-2"></div>
            </div>
            <div className="banner-content">
              <h2>Explore Opportunities With Us</h2>
              <p>For any related queries, reach out to our HR team</p>
              <a href="mailto:hr@ak-tech.in" className="reach-now-btn">
                Reach Now
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default CareerPage;